import _join from "ramda/es/join";
import _pipe from "ramda/es/pipe";
import _insert from "ramda/es/insert";
import _curry from "ramda/es/curry";
import onlyDigits from './onlyDigits';

var insertSlash = _curry(function (idx, list) {
  return _insert(idx, ' / ', list);
});

export default _pipe(onlyDigits, insertSlash(3), insertSlash(8), _join(''), function (s) {
  return "+++ ".concat(s, " +++");
});